import {AddressChangeForOwner as AddressChangeForOwnerLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

export type AddressChangeForOwnerProps = {
  addressChangeForOwnerLetter: AddressChangeForOwnerLetter;
};

const AddressChangeForOwner = (props: AddressChangeForOwnerProps) => {
  return (
    <>
      <CardField name="Owner Name" value={props.addressChangeForOwnerLetter.ownerName} ddprivacy="mask"/>
      <CardField name="Owner Address" value={props.addressChangeForOwnerLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name="Insured Name" value={props.addressChangeForOwnerLetter.insuredName} ddprivacy="mask"/>
      <CardField name="Insured Address" value={props.addressChangeForOwnerLetter.insuredAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name="Policy Number" value={props.addressChangeForOwnerLetter.policyNumber} ddprivacy="mask"/>
      <CardField name="Date" value={toFormattedDateAsUTC(props.addressChangeForOwnerLetter.date)} />
      <CardField name="Agent Number" value={props.addressChangeForOwnerLetter.agentNumber} />
    </>
  );
};

export default AddressChangeForOwner;
